import md5 from 'js-md5';
import { localizedProviderTitleId, localeService } from '../../core/helpers';
export const hasDayPass = (user) => {
    if (!user.dayPassEndDate) {
        return false;
    }
    return new Date(user.dayPassEndDate).getTime() > Date.now();
};
export const getDisplayName = (user) => {
    if (!Boolean(user.id)) {
        return '';
    }
    const title = user.title &&
        localeService.formatMessageById(localizedProviderTitleId(user.title));
    const lastNameWithTitle = !['', 'Other'].includes(user.title)
        ? `${title} ${user.lastName}`
        : `${user.lastName}`;
    return Boolean(user.displayName) && user.displayName !== ''
        ? user.displayName
        : lastNameWithTitle;
};
const gravatarIdCache = {};
export const getProfilePictureUrl = ({ user, size = 64, }) => {
    if (!user.useProfilePicture) {
        return null;
    }
    const defaultImage = '/assets/icons/legacy/avatar.svg';
    let url = '';
    switch (user.profilePictureProvider) {
        case 'doxymeProfilePicture':
        case 'LinkedIn':
            url = user.userProfilePictureUrl ?? defaultImage;
            break;
        case 'gravatar': {
            const gravatarEmail = gravatarIdCache[user.email];
            const gravatarId = gravatarEmail ?? md5((user.email ?? '').trim().toLowerCase());
            if (!Boolean(gravatarEmail)) {
                gravatarIdCache[user.email] = gravatarId;
            }
            url = Boolean(gravatarId)
                ? `https://www.gravatar.com/avatar/${gravatarId}?s=${size}`
                : defaultImage;
            break;
        }
        default:
            url = defaultImage;
    }
    return url;
};
